export default {
    notification: null
}
